/* eslint-disable no-alert */
/**
 *  Module -- Header
 */
const header = {
  el: $('.header'),
  init() {
    if (this.tbtMenu.el.length > 0) {
      this.tbtMenu.init();
    }
    if (this.search.trigger.length > 0) {
      this.search.init();
    }
    this.sticky();
    this.subnav.init();
    this.search.quickLink.init();
    this.share.init();
  },
  tbtMenu: {
    el: $('.header__nav-tbt-menu'),
    init() {
      this.toggleMenu();
    },
    toggleMenu() {
      const menuIcon = this.el.find('.header__nav-menu-icon');
      menuIcon.click(() => {
        this.el.toggleClass('open');
      });
    }
  },
  sticky() {
    const self = this;
    const waypoint = new Waypoint({
      element: $('#header--waypoints'),
      handler(dir) {
        if (dir === 'down' && $(window).width() > mobileBp) {
          self.el.addClass('header--sticky');
          if ($('.hero-banner__video').length > 0 && !$('.hero-banner__video video').get(0).paused) {
            $('.hero-banner__video video').get(0).pause();
          }
        } else if (dir === 'up' && $(window).width() > mobileBp) {
          self.el.removeClass('header--sticky');
          if ($('.hero-banner__video').length > 0 && $('.hero-banner__video video').get(0).paused) {
            $('.hero-banner__video video').get(0).play();
          }
        }
      },
      offset: -200
    });

    $(window).on('resize', debounce(() => {
      if ($(window).width() <= mobileBp) {
        this.el.removeClass('header--sticky');
      } else if ($(document).scrollTop() > 200) {
        this.el.addClass('header--sticky');
      }
    }, 250));
  },
  subnav: {
    el: $('.header__subnav'),
    init() {
      if (this.el.length > 0) {
        this.posAdj();
        this.hoverTab();
        this.resize();
      }
    },
    posAdj() {
      this.el.each(function () {
        const thisEl = $(this);
        const thisElTng = thisEl.find('.header__subnav-tng'); // the small triangle
        const firstColWidth = thisEl.find('.header__subnav-col').first().outerWidth();
        const parentNavWidth = thisEl.parent('.header__nav-item').width();

        let adjSizeTng = firstColWidth / 2 - 10;
        let adjSize = (firstColWidth - parentNavWidth) / 2;
        const ww = $(window).outerWidth();
        // const eleWidth = thisEl.outerWidth() + thisEl.offset().left;
        const eleWidth = 590 + (thisEl.parent('.header__nav-item').offset().left - adjSize);
        if (eleWidth > ww) {
          adjSize += eleWidth - ww;
          adjSizeTng += eleWidth - ww;
        }
        thisEl.css({
          transform: `translateX(-${adjSize}px)`,
        });
        thisElTng.css({
          transform: `translateX(${adjSizeTng}px)`
        });
      });
    },
    hoverTab() {
      const subnavLink = $('.header__subnav-link');
      const subnavDetail = $('.header__subnav-detail');
      subnavLink.mouseenter(function () {
        const thisLink = $(this);
        const thisTarget = thisLink.attr('data-hover-target');
        const currentVisibleId = `#${$('.header__subnav-detail:visible').attr('id')}`;
        if (thisTarget !== undefined && currentVisibleId !== thisTarget) {
          subnavDetail.hide();
          $(thisTarget).fadeIn(500, defaultEasing);
        }
      });
    },
    resize() {
      $(window).on('resize', debounce(() => {
        this.posAdj();
      }, 250));
    }
  },
  search: {
    trigger: $('.js-search'),
    tableTrigger: $('.js-search-table'),
    input: $('.js-search-input'),
    target: $('.js-search-overlay'),
    searchTrigger: $('.js-search-overlay-search'),
    bg: $('.js-search-overlay-bg'),
    clear: $('.js-search-clear'),
    init() {
      // this.hideClear();
      this.event();
    },
    open() {
      this.target.addClass('active').find('input').focus();
      bodyScrollLock.disableBodyScroll();
    },
    close() {
      this.target.removeClass('active');
      bodyScrollLock.enableBodyScroll();
    },
    clearVal() {
      this.target.find('input').val('');
      this.hideClear();
    },
    event() {
      this.trigger.click(() => {
        this.open();
      });
      this.tableTrigger.click(() => {
        this.tableOpen();
      });
      this.bg.click(() => {
        this.close();
      });
      this.clear.click(() => {
        this.clearVal();
      });
      this.input.on('keyup', () => {
        if (this.input.val().length > 0) {
          this.showClear();
        } else {
          this.hideClear();
        }
      });
      this.searchTrigger.click(() => {
        $('.js-search-form').submit();
      });
    },
    tableOpen() {
      const menu = $('.header__nav-tbt-menu');
      menu.removeClass('open');
      this.open();
    },
    showClear() {
      this.clear.show();
    },
    hideClear() {
      this.clear.hide();
    },
    quickLink: {
      form: $('#js-header-search-quick'),
      input: $('#js-header-search-quick-input'),
      init() {
        this.submit();
      },
      submit() {
        const el = $('.js-header-search-quick-btn');
        const self = this;
        el.click(function (e) {
          e.preventDefault();
          const thisEl = $(this);
          const thisValue = thisEl.data('value');
          self.input.val(thisValue);
          self.form.submit();
        });
      }
    },
  },
  share: {
    mobileEl: $('.js-share-mobile'),
    init() {
      this.event.on.init();
    },
    event: {
      on: {
        init() {
          this.click();
        },
        click() {
          const { share } = header;
          const { eventFunc } = header.share;
          share.mobileEl.on('click', eventFunc.click);
        }
      }
    },
    eventFunc: {
      click(e) {
        e.preventDefault();
        const thisLink = $(this);
        if (navigator.share) {
          navigator.share({
            title: $('title').text(),
            url: window.location.href
          })
            .catch(() => {
              alert(thisLink.data('not-support'));
            });
        } else {
          alert(thisLink.data('not-support'));
        }
      }
    }
  }
};

$(document).ready(() => {
  if (header.el.length > 0) {
    header.init();
  }
});